import type { PropsWithChildren } from "react";
import React from "react";

import * as styles from "./InfoBlock.css";

export type InfoBlockProps = PropsWithChildren;

export const InfoBlock: React.FC<InfoBlockProps> = ({ children }) => {
  return <div className={styles.infoBlockStyle}>{children}</div>;
};
